<template>
  <div class="part">
    <div class="con">
      <div class="left">
        <div >
          <span class="icon-logo"></span>
          <span class="left-title">为销售赋能的小程序名片</span>
        </div>
        <div class="nav">
          <a class="nav-item" href="/siteindex/#/">小官网</a>
          <a class="nav-item" href="/card/#/">小名片</a>
          <a class="nav-item" href="/#/invest">招商加盟</a>
          <a class="nav-item" href="/#/help">帮助指引</a>
          <a class="nav-item" href="/#/about">关于我们</a>
        </div>
        <!--友情链接-->
        <div class="links">
          <span >友情链接： </span><a href="http://www.apluscap.com/" target="_blank">洪泰基金</a><a href="http://www.taiyoufund.com/" target="_blank">泰有投资</a><a href="http://cn.idgcapital.com/" target="_blank">IDG资本</a>
          <a href="http://www.cmhk.com/main/" target="_blank">招商局</a><a href="http://www.oppein.com/" target="_blank">欧派</a><a href="http://www.bbwgw.com/cms/" target="_blank">北部港湾</a><a href="http://www.geya-watch.com/" target="_blank">Geya格雅表</a><a href="https://m.kuaidi100.com/" target="_blank">快递查询</a>
        </div>
      </div>

      <div class="right">
        <div class="title">联系方式</div>
        <div class="cell">电话： 186 8021 1000</div>
        <div class="cell">电子邮箱： chenjianjun@xcxzhan.com</div>
      </div>

    </div>
    <div class="copyright">
      &copy;2010-{{ year }} 广州群应用网络科技有限公司 <a href="http://beian.miit.gov.cn" target="_blank">粤ICP备17114055号</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地址： 广州市天河区华景路37号暨南大学科技园6楼
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      year: (new Date()).getFullYear()
    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
@import "../../common/common.scss";
$max-width: 1280px;
.part{
  background-color:$theme-color;
  color:#fff;
  line-height: 1.0;
  font-size: 16px;
  padding: 0 20px;
  min-width: $min-width;
  box-sizing: border-box;
  .con{
    margin: 0 auto;
    @include clearfix;
    padding-top: 40px;
    padding-bottom: 30px;
    border-bottom: 1px solid #fff;
    max-width: $max-width;
    .left{
      float: left;
      .icon-logo{
        display:inline-block;
        width: 120px;
        height: 25px;
        background-image: url("../../assets/images/card-logo-white.png");
        vertical-align:middle;
      }
      .left-title{
        padding-left: 10px;
        border-left: 1px solid #fff;
        margin-left: 10px;
        vertical-align: middle;
      }

      .nav{
        margin-top:20px;
        font-size: 14px;
        line-height: 18px;
        .nav-item{
          padding-right: 48px;
          & + .nav-item{
            border-left: 1px solid #fff;
            padding-left: 36px;
          }
        }
        a:link,a:visited{
          color:#fff;
        }
        a:hover{
          color:#9be6b5;
        }
      }
      .links{
        margin-top: 20px;
        color:#9be6b5;
        font-size: 14px;
        a{
          color:#9be6b5;
          & + a{
            margin-left: 10px;
          }
          &:hover{
            color:#fff;
          }
        }
      }
    }
    .right{
      float: right;
      .title{
        font-size: 18px;
        margin-bottom: 26px;
        margin-top: 12px;
      }
      .cell{
        font-size: 14px;
        color:#9be6b5;
        & + .cell{
          margin-top: 18px;
        }
      }
    }
  }
  .copyright{
    font-size: 14px;
    color:#9be6b5;
    padding: 18px 0 32px;
    margin: 0 auto;
    max-width: $max-width;
    a{
      color:#9be6b5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/zcx/components/business/CommonFooter.vue